import React from "react";
import {
    QuickFilter,
    QuickFilterControl,
    QuickFilterClear,
} from "@mui/x-data-grid";
import { TextField, InputAdornment } from "@mui/material";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import { appSearchFieldSx } from "./dataGridStyles.js";

/**
 * Always-expanded, outlined quick filter — no icon-only trigger.
 */
export default function AppGridQuickFilter({
    placeholder = "Search…",
    sx,
    debounceMs = 300,
    ...rest
}) {
    return (
        <QuickFilter defaultExpanded expanded debounceMs={debounceMs} {...rest}>
            <QuickFilterControl
                render={({ ref, ...controlProps }) => (
                    <TextField
                        {...controlProps}
                        inputRef={ref}
                        size="small"
                        variant="outlined"
                        placeholder={placeholder}
                        aria-label={placeholder}
                        sx={{ ...appSearchFieldSx, ...sx }}
                        slotProps={{
                            ...(controlProps.slotProps || {}),
                            input: {
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchOutlinedIcon
                                            sx={{ fontSize: 18, color: "#9aa3ad" }}
                                        />
                                    </InputAdornment>
                                ),
                                endAdornment: controlProps.value ? (
                                    <InputAdornment position="end">
                                        <QuickFilterClear
                                            aria-label="Clear search"
                                            size="small"
                                            edge="end"
                                            sx={{ color: "#9aa3ad" }}
                                        >
                                            <ClearOutlinedIcon fontSize="small" />
                                        </QuickFilterClear>
                                    </InputAdornment>
                                ) : null,
                                ...(controlProps.slotProps?.input || {}),
                            },
                        }}
                    />
                )}
            />
        </QuickFilter>
    );
}
